/* eslint-disable @typescript-eslint/no-explicit-any */
import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import PurchaseByGoodsTable from './PurchaseByGoodsTable';
import GoodsFilter from './filter/GoodsFilter';

import './styles.scss';
import queryClient from 'service/queryClient';
import ButtonRefresh from 'components/base/ButtonRefresh';

export const goodsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: 'reports',
    url: '/reports/purchase/invoice'
  },
  {
    label: 'purchase',
    url: '/reports/purchase/invoice'
  },

  {
    label: 'purchase_products',
    active: true
  }
];

const PurchaseByGoods = () => {
  const { t } = useTranslation();
  const barcodeInputRef = useRef<HTMLInputElement>(null);

  const [generateTableData, setGeneratedTableData] = useState([]);
  const [savedValues, setSavedValues] = useState([]);
  const [getName, setGetName] = useState('');
  const [getBarcode, setGetBarcode] = useState('');
  const [getFilterData, setFilterData] = useState({});
  const [totalAmount, setTotalAmount] = useState<any>([]);
  const [debouncedBarcode, setDebouncedBarcode] = useState('');
  const [pageCount, setPageCount] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [labeledVisibleFields, setLabeledVisibleFields] = useState<any>('');

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
      setTimeout(() => barcodeInputRef.current?.select(), 500);
    }
  }, []);

  return (
    <div>
      <PageBreadcrumb items={goodsBreadcrumbItems} />
      <div>
        <div className="mb-5 d-flex gap-2 align-items-center">
          <h2>{t('purchase_products')}</h2>
          <ButtonRefresh
            onRefresh={() => {
              queryClient.refetchQueries('GET_REPORTS_PRODUCT');
            }}
          />
        </div>
        <GoodsFilter
          setGeneratedTableData={setGeneratedTableData}
          savedValues={savedValues}
          setSavedValues={setSavedValues}
          setGetName={setGetName}
          setGetBarcode={setGetBarcode}
          getName={getName}
          getBarcode={getBarcode}
          setFilterData={setFilterData}
          setTotalAmount={setTotalAmount}
          getFilterData={getFilterData}
          barcodeInputRef={barcodeInputRef}
          setDebouncedBarcode={setDebouncedBarcode}
          currentPage={currentPage}
          setPageCount={setPageCount}
          setCurrentPage={setCurrentPage}
          labeledVisibleFields={labeledVisibleFields}
        />
        <PurchaseByGoodsTable
          generateTableData={generateTableData}
          setGeneratedTableData={setGeneratedTableData}
          getName={getName}
          getFilterData={getFilterData}
          totalAmount={totalAmount}
          setTotalAmount={setTotalAmount}
          barcodeInputRef={barcodeInputRef}
          debouncedBarcode={debouncedBarcode}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          pageCount={pageCount}
          setPageCount={setPageCount}
          setLabeledVisibleFields={setLabeledVisibleFields}
        />
      </div>
    </div>
  );
};

export default PurchaseByGoods;
